// extracted by mini-css-extract-plugin
export var dateLabel = "_47-0";
export var dateLabelError = "_47-1";
export var fullWidth = "_47-2";
export var smaller = "_47-3";